import { T } from '@tolgee/react';

import GreenCheckSvg from '../../../assets/icons/GreenCheckSvg';
import RedStopSvg from '../../../assets/icons/RedStopSvg';

export const featureCompareTableData: {
  heading: string | JSX.Element;
  rows: {
    feature: React.ReactNode;
    basic: React.ReactNode;
    premium: React.ReactNode;
    schoolPlan: React.ReactNode;
  }[];
}[] = [
  {
    heading: <T keyName="Content" defaultValue="Content" />,
    rows: [
      {
        feature: (
          <strong>
            <T
              keyName="Unlimited student participants"
              defaultValue="Unlimited student participants"
            />
          </strong>
        ),
        basic: <GreenCheckSvg />,
        premium: <GreenCheckSvg />,
        schoolPlan: <GreenCheckSvg />,
      },
      {
        feature: (
          <strong>
            <T keyName="Teaching sessions" defaultValue="Teaching sessions" />
          </strong>
        ),
        basic: (
          <T
            keyName="Weekly sessions included (renews every week)"
            defaultValue="Weekly sessions included (renews every week)"
          />
        ),
        premium: <T keyName="Unlimited" defaultValue="Unlimited" />,
        schoolPlan: <T keyName="Unlimited" defaultValue="Unlimited" />,
      },
      {
        feature: (
          <strong>
            <T
              keyName="Standards alignment (national and state)"
              defaultValue="Standards alignment (national and state)"
            />
          </strong>
        ),
        basic: <RedStopSvg />,
        premium: <GreenCheckSvg />,
        schoolPlan: <GreenCheckSvg />,
      },
      {
        feature: (
          <strong>
            <T
              keyName="AI-powered features (AI feedback, lesson generation, translations)"
              defaultValue="AI-powered features (AI feedback, lesson generation, translations)"
            />
          </strong>
        ),
        basic: (
          <>
            <GreenCheckSvg />{' '}
            <span>
              <T keyName="Included" defaultValue="Included" />
            </span>
          </>
        ),
        premium: <T keyName="Unlimited" defaultValue="Unlimited" />,
        schoolPlan: <T keyName="Unlimited" defaultValue="Unlimited" />,
      },
      {
        feature: (
          <>
            <strong>
              <T keyName="Test prep" defaultValue="Test prep" />
            </strong>{' '}
            <T
              keyName="Access to customize thousands of standards aligned state test prep lessons for all 50 states (3rd-12th grade) + ACT"
              defaultValue="Access to customize thousands of standards aligned state test prep lessons for all 50 states (3rd-12th grade) + ACT"
            />
          </>
        ),
        basic: (
          <T
            keyName="Try select test prep content for free"
            defaultValue="Try select test prep content for free"
          />
        ),
        premium: <RedStopSvg />,
        schoolPlan: (
          <T
            keyName="Full access to all test prep libraries"
            defaultValue="Full access to all test prep libraries"
          />
        ),
      },
      {
        feature: (
          <strong>
            <T
              keyName="Curipod Immersive standards aligned (CCSS & TEKS) reading and writing ELA package for middle school"
              defaultValue="Curipod Immersive standards aligned (CCSS & TEKS) reading and writing ELA package for middle school"
            />
          </strong>
        ),
        basic: <RedStopSvg />,
        premium: <GreenCheckSvg />,
        schoolPlan: <GreenCheckSvg />,
      },
      {
        feature: (
          <strong>
            <T
              keyName="Bilingual (ESL/ELL) Lessons"
              defaultValue="Bilingual (ESL/ELL) Lessons"
            />
          </strong>
        ),
        basic: <RedStopSvg />,
        premium: <GreenCheckSvg />,
        schoolPlan: <GreenCheckSvg />,
      },
    ],
  },
  {
    heading: <T keyName="Customization" defaultValue="Customization" />,
    rows: [
      {
        feature: (
          <strong>
            <T
              keyName="Customize Lessons using your own Rubric"
              defaultValue="Customize Lessons using your own Rubric"
            />
          </strong>
        ),
        basic: <RedStopSvg />,
        premium: <GreenCheckSvg />,
        schoolPlan: <GreenCheckSvg />,
      },
      {
        feature: (
          <strong>
            <T
              keyName="Student Written Responses"
              defaultValue="Student Written Responses"
            />
          </strong>
        ),
        basic: (
          <T keyName="up to 1,000 characters" defaultValue="up to 1,000 characters" />
        ),
        premium: (
          <T keyName="up to 2,300 characters" defaultValue="up to 2,300 characters" />
        ),
        schoolPlan: (
          <T keyName="up to 2,300 characters" defaultValue="up to 2,300 characters" />
        ),
      },
      {
        feature: (
          <strong>
            <T keyName="Content Translations" defaultValue="Content Translations" />
          </strong>
        ),
        basic: <T keyName="Limited" defaultValue="Limited" />,
        premium: <T keyName="Unlimited" defaultValue="Unlimited" />,
        schoolPlan: <T keyName="Unlimited" defaultValue="Unlimited" />,
      },
      {
        feature: (
          <>
            <strong>
              <T
                keyName="Download Lessons as PDF and Share Results"
                defaultValue="Download Lessons as PDF and Share Results"
              />
            </strong>{' '}
            <T
              keyName="(for absent students, offline access, etc.)"
              defaultValue="(for absent students, offline access, etc.)"
            />
          </>
        ),
        basic: <RedStopSvg />,
        premium: <GreenCheckSvg />,
        schoolPlan: <GreenCheckSvg />,
      },
      {
        feature: (
          <>
            <strong>
              <T keyName="Student Insights" defaultValue="Student Insights" />
            </strong>{' '}
            <T
              keyName="(aligned to your Standard and Learning Objective)"
              defaultValue="(aligned to your Standard and Learning Objective)"
            />
          </>
        ),
        basic: <RedStopSvg />,
        premium: <GreenCheckSvg />,
        schoolPlan: <GreenCheckSvg />,
      },
      {
        feature: (
          <strong>
            <T
              keyName="Shared lesson folders across schools & district"
              defaultValue="Shared lesson folders across schools & district"
            />
          </strong>
        ),
        basic: <RedStopSvg />,
        premium: <RedStopSvg />,
        schoolPlan: <GreenCheckSvg />,
      },
    ],
  },
  {
    heading: (
      <T keyName="Implementation & Support" defaultValue="Implementation & Support" />
    ),
    rows: [
      {
        feature: (
          <strong>
            <T keyName="Customer Support" defaultValue="Customer Support" />
          </strong>
        ),
        basic: <T keyName="Basic support" defaultValue="Basic support" />,
        premium: <T keyName="Basic support" defaultValue="Basic support" />,
        schoolPlan: <T keyName="Priority support" defaultValue="Priority support" />,
      },
      {
        feature: (
          <>
            <strong>
              <T keyName="SSO" defaultValue="SSO" />
            </strong>{' '}
            <T
              keyName="(Classlink, Clever, Google, etc)"
              defaultValue="(Classlink, Clever, Google, etc)"
            />
          </>
        ),
        basic: <RedStopSvg />,
        premium: <RedStopSvg />,
        schoolPlan: <GreenCheckSvg />,
      },
      {
        feature: (
          <strong>
            <T keyName="Implementation Support" defaultValue="Implementation Support" />
          </strong>
        ),
        basic: <RedStopSvg />,
        premium: <T keyName="Self-serve courses" defaultValue="Self-serve courses" />,
        schoolPlan: <GreenCheckSvg />,
      },
    ],
  },
  {
    heading: (
      <T keyName="Data Privacy & AI Safety" defaultValue="Data Privacy & AI Safety" />
    ),
    rows: [
      {
        feature: (
          <strong>
            <T keyName="Compliant with:" defaultValue="Compliant with:" />
          </strong>
        ),
        basic: (
          <T
            keyName="All federal and state privacy laws, including FERPA, COPPA, SOPPA, GDPR Compliant"
            defaultValue="All federal and state privacy laws, including FERPA, COPPA, SOPPA, GDPR Compliant"
          />
        ),
        premium: (
          <T
            keyName="All federal and state privacy laws, including FERPA, COPPA, SOPPA, GDPR Compliant"
            defaultValue="All federal and state privacy laws, including FERPA, COPPA, SOPPA, GDPR Compliant"
          />
        ),
        schoolPlan: (
          <T
            keyName="All federal and state privacy laws, including FERPA, COPPA, SOPPA, GDPR Compliant"
            defaultValue="All federal and state privacy laws, including FERPA, COPPA, SOPPA, GDPR Compliant"
          />
        ),
      },
      {
        feature: (
          <strong>
            <T keyName="Training of AI Models" defaultValue="Training of AI Models" />
          </strong>
        ),
        basic: (
          <T
            keyName="No student or teacher data used"
            defaultValue="No student or teacher data used"
          />
        ),
        premium: (
          <T
            keyName="No student or teacher data used"
            defaultValue="No student or teacher data used"
          />
        ),
        schoolPlan: (
          <T
            keyName="No student or teacher data used"
            defaultValue="No student or teacher data used"
          />
        ),
      },
      {
        feature: (
          <strong>
            <T
              keyName="Teacher can control and review all AI output before it's received by students"
              defaultValue="Teacher can control and review all AI output before it's received by students"
            />
          </strong>
        ),
        basic: <GreenCheckSvg />,
        premium: (
          <>
            <GreenCheckSvg />{' '}
            <span>
              <T keyName="Real time moderation" defaultValue="Real time moderation" />
            </span>
          </>
        ),
        schoolPlan: (
          <>
            <GreenCheckSvg />{' '}
            <span>
              <T keyName="Real time moderation" defaultValue="Real time moderation" />
            </span>
          </>
        ),
      },
      {
        feature: (
          <strong>
            <T keyName="Data privacy agreements" defaultValue="Data privacy agreements" />
          </strong>
        ),
        basic: (
          <T
            keyName="❌ standard privacy policy"
            defaultValue="❌ standard privacy policy"
          />
        ),
        premium: (
          <T
            keyName="❌ standard privacy policy"
            defaultValue="❌ standard privacy policy"
          />
        ),
        schoolPlan: <GreenCheckSvg />,
      },
    ],
  },
];
